import React from "react";
import { DocAcciones } from "@/components/documentos/DocAcciones";
import { FileText, Image as ImageIcon, Trash2, Eye, Loader2, FolderOpen, FolderInput } from "lucide-react";

export const DocRow = ({ doc, subtitle, rutas, idx = 0, opening, onOpen, onDelete, onAsignar, testid }) => {
  const Icon = doc.type === "Imagen" ? ImageIcon : FileText;
  return (
    <div data-testid={testid} style={{ animationDelay: `${Math.min(idx, 10) * 40}ms` }}
      className="aldia-fade-up bg-white border border-[#E5DFD5] rounded-2xl p-4 flex flex-wrap items-center gap-x-4 gap-y-1">
      <div className="shrink-0 w-12 h-12 rounded-xl bg-[#E8F0EC] flex items-center justify-center">
        <Icon size={24} className="text-[#3A6B56]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-heading font-bold text-base text-[#1C2421] line-clamp-2 break-words">{doc.filename}</p>
        {doc.sustituida && <p data-testid={`${testid}-sustituida`} className="text-sm text-[#6E7A74]"><span className="inline-block px-2 py-0.5 rounded-full bg-[#E5DFD5] text-[#4A5550] font-bold">Sustituida</span> Hay una tarjeta más reciente</p>}
        {subtitle && <p className="text-sm text-[#6E7A74] truncate">{subtitle}</p>}
        {rutas?.map((r) => (
          <p key={r} data-testid={`${testid}-ruta`} className="text-sm text-[#3A6B56] font-semibold flex items-center gap-1 mt-0.5 min-w-0">
            <FolderOpen size={14} className="shrink-0" /> <span className="truncate">{r}</span>
          </p>
        ))}
      </div>
      <button data-testid={`documento-open-${doc.id}`} onClick={() => onOpen(doc)} disabled={opening === doc.id} aria-label="Ver documento"
        className="w-11 h-11 rounded-lg bg-[#F2EDE4] flex items-center justify-center hover:bg-[#E5DFD5] disabled:opacity-60 shrink-0">
        {opening === doc.id ? <Loader2 size={18} className="text-[#4A5550] animate-spin" /> : <Eye size={18} className="text-[#4A5550]" />}
      </button>
      <button data-testid={`documento-delete-${doc.id}`} onClick={() => onDelete(doc)} aria-label="Eliminar documento"
        className="w-11 h-11 rounded-lg bg-[#FEF2F2] flex items-center justify-center hover:bg-[#FEE2E2] shrink-0">
        <Trash2 size={18} className="text-[#B91C1C]" />
      </button>
      <div className="w-full flex flex-wrap items-center gap-2">
        {onAsignar && (
          <button data-testid={`documento-asignar-${doc.id}`} onClick={() => onAsignar(doc)}
            className="mt-2 inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-xl bg-[#D97706] text-white font-semibold text-sm hover:bg-[#B45309]">
            <FolderInput size={16} /> Asignar
          </button>
        )}
        <div className="flex-1 min-w-0"><DocAcciones doc={doc} mover={!onAsignar} testid={`documento-acc-${doc.id}`} /></div>
      </div>
    </div>
  );
};
